import type { EmailFilter } from "../features/email-filters/model";
import API, { responseOf } from "./base";

export const createEmailFilter = async ({
  address,
  org_id,
  filter_action,
  expiration_time,
}: EmailFilter): Promise<void> => {
  await API.post(
    `/email-filters/${org_id}/create?address=${address}&action=${filter_action}&expires=${Math.round(
      (expiration_time?.getTime() ?? 0) / 1000,
    )}`,
  );
};

export const deleteEmailFilters = async (
  organizationId: string,
  addresses: string[],
): Promise<void> => {
  await API.delete(`/email-filters/${organizationId}/delete`, {
    data: addresses,
  });
};

export const getEmailFilter = (
  organizationId: string,
  address: string,
): Promise<EmailFilter> =>
  responseOf(
    API.get(`/email-filters/${organizationId}/query?address=${address}`),
  );

export const listEmailFilters = (
  organizationId: string,
): Promise<EmailFilter[]> =>
  responseOf(API.get(`/email-filters/${organizationId}`));
